import React from 'react'
import { Dispatch } from 'redux'
import { LinkProps, NavigateAction } from '../types'
import { navigate } from '../actions'
import { connect } from 'react-redux'

class App extends React.Component<LinkProps> {

  _handleClick = (event: React.MouseEvent | any) => {
    event.preventDefault()
    this.props.navigate(this.props.route)
  }

  render() {
    let props = { ...this.props }
    if(props.children) delete props.children
    delete props.navigate
    delete props.route

    return (
      <a
        onClick={this._handleClick}
        href={this.props.route}
        {...props}
      >
        {this.props.children}
      </a>
    )
  }

}

const mapDispatchToProps = (dispatch: Dispatch): { navigate(route: string): NavigateAction } => ({
  navigate: (route: string) => dispatch(navigate(route))
})

export default connect(null, mapDispatchToProps)(App)
